import Flickity from 'flickity';

const carousels = [];

export default function () {
  document.querySelectorAll('[data-blog-article-thumb-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }
    if (el.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {
      contain: true,
      groupCells: true,
      wrapAround: true,
    });

    carousels.push(carousel);
  });
}
